export default __webpack_public_path__ + "static/media/whatsapp.3ff0c4cf.png";